import { getBearerToken } from "../../../../../../api/postCall/bearerToken";
import { CoverMyMedsInputModel } from "../../../../../../data-model/cmmInputRequestModel";
import { API_ENDPOINTS } from "../../../../../../enums/apiUrls";

/**
 * Fetches a single cmm_input row from BigQuery for the given identifier and org.
 *
 * @param identifier - Order identifier to look up
 * @param orgId - Organization id used for BigQuery dataset routing
 * @returns CoverMyMedsInputModel for the matched row
 */
export const fetchCmmInputData = async (
  identifier: string,
  orgId: string,
) => {
  const token = await getBearerToken();

  const payload = {
    org_id: orgId,
    dataset_name: "oncoemr",
    table_name: "cmm_input",
    order_by: [
      {
        column: "created_at",
        direction: "DESC",
      },
    ],
    filters: {
      identifier: [identifier],
    },
    page_size: 1,
    unnest: true,
  };

  const response = await fetch(API_ENDPOINTS.GET_PHARMA_STP_FILE_DATA, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  const data = await response.json();
  const rows: any[] = data?.rows ?? data?.details ?? [];

  if (!rows.length) {
    throw new Error("No order data found for the given identifier");
  }

  return rows[0] as CoverMyMedsInputModel;
};
